import * as Phaser from "phaser-ce"
import { GameState } from "../GameState"
import { AudioSync } from "../utils/AudioSync"
import { CameraZoom } from "../utils/CameraZoom"
import { Scale } from "../utils/Scale"
import { GenericAssets } from "./GenericAssets"
import { Sound } from "./lip-sync/Sound"
import { Word } from "./lip-sync/Word"

export class ScientistSprite extends Phaser.Sprite {

    audio: Phaser.Sound
    mouth: Phaser.Sprite

    constructor(
        game: Phaser.Game, x: number, y: number, audioKey: string, defaultScale: number, words: Array<Word> = [],
        group?: Phaser.Group, goToWhenComplete?: GameState, onDone: (() => void | undefined) = undefined, nextButton?: Phaser.Button
    ) {
        super(game, x, y, GenericAssets.SCIENTIST)
        this.audio = game.add.audio(audioKey)
        if (nextButton) {
            this.audio.onPlay.add(() => nextButton.inputEnabled = false)
            this.audio.onStop.add(() => nextButton.inputEnabled = true)
        }
        const wordTimer = new AudioSync(game, this.audio)
        this.audio.play()

        if (goToWhenComplete) {
            this.audio.onStop.add(() => {
                const experimentOver = this.game.time.create(true)
                experimentOver.add(1500, () => {
                    this.game.state.start(goToWhenComplete)
                })
                experimentOver.start()
            })
        }
        if (onDone) {
            this.audio.onStop.add(onDone)
        }

        Scale.scaleSprite(this, defaultScale)
        const mouthX = x + (Scale.width() * 0.16 * defaultScale)
        const mouthY = y + (Scale.height() * 0.351 * defaultScale)
        this.mouth = new Phaser.Sprite(game, mouthX, mouthY, GenericAssets.MOUTH_POSITIONS)
        Scale.scaleSprite(this.mouth, defaultScale)

        if (group) {
            group.add(this)
            group.add(this.mouth)
        } else {
            this.game.add.existing(this)
            this.game.add.existing(this.mouth)
        }

        let previousWordEnd = 0
        words.forEach((word) => {
            if (word.start >= word.end) {
                throw new Error("Word start must be less than word end. Start: " + word.start)
            }
            if (word.start < previousWordEnd) {
                throw new Error("The next word's start must be greater than the previous word's end. End: "
                    + previousWordEnd + " Start: " + word.start)
            }
            previousWordEnd = word.end
            let wordTime = word.start
            word.sounds.forEach((sound) => {
                wordTimer.add(wordTime, () => {
                    this.mouth.frame = sound
                })
                wordTime += word.soundDuration
            })
            wordTimer.add(word.end, () => {
                this.mouth.frame = Sound.CLOSED
            })
        })
        wordTimer.start()
    }

    slideTo = (slideToX: number) => {
        CameraZoom.moveSprite(this, slideToX)
        CameraZoom.moveSprite(this.mouth, this.mouth.x + slideToX - this.x)
    }

    changeImage = (resource: string, mouthScale: number, mouthX: number, mouthY: number) => {
        this.loadTexture(resource)
        this.mouth.x = mouthX
        this.mouth.y = mouthY
        Scale.scaleSprite(this.mouth, mouthScale)
    }
}
